import { render, staticRenderFns } from "./verifyId.vue?vue&type=template&id=321d2eb0&"
import script from "./verifyId.vue?vue&type=script&lang=js&"
export * from "./verifyId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports